<template>
  <CompanyNameAvatarColumn v-if="column" :row="column.job.company" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import CompanyNameAvatarColumn from '@/components/GraphqlDataTable/columns/Company/CompanyNameAvatarColumn.vue'

const frag = graphql(`
  fragment JobShareCompanyColumn on JobShare {
    id
    job {
      id
      company {
        name
        ...CompanyNameAvatarColumn
      }
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof frag> }>()
const column = computed(() => useFragment(frag, props.row))
</script>
